import { PruToast } from "../../../../components/pru-toast";
import { sendOtpReq } from "../../../prudna/network/network";
import { SurveyModel } from "survey-core";
import { handlerError } from "./handle-otp-error";
import { getI18n } from "react-i18next";
import { get } from "lodash";
import {
  EndAdornment,
  regionPhoneValidate,
} from "../../../onboarding/components/surveyjs/survey/survey.util";
//PHKL Custom -s
import { GlobalHelper } from "../../../../utils/helpers/global-helper";
import { commonSlice } from "../../../../redux/common/common-slice";
//PHKL Custom -e
import { addUniqueErrorToQuestion } from "../../../onboarding/pages/form/survey.util";

let oid: string | undefined = undefined;

const { sendOtpStartTimingAction } = commonSlice.actions; //PHKL Custom
export const sendOtpFunc = async (params: any[]) => {
  const [value, survey, config] = params as [string, SurveyModel, EndAdornment];
  const regionValue = survey.getQuestionByName("regionPhone")?.value?.[0];
  const actionParams = survey.getQuestionByName("otp")?.otpConfig?.actionParams; //PHKL Custom
  const code = regionValue?.regionCode;
  const phoneNumber = regionValue?.phoneNumber;
  if (!regionPhoneValidate([code, phoneNumber])) {
    // PHKL Custom -s
    // PruToast({
    //   message: getI18n().t("Recruitment.invalid_phone_number"),
    //   duration: 3000,
    // });
    const regionPhone = survey.getQuestionByName("regionPhone");
    const phoneNumber = regionPhone.getNestedQuestions()[1];
    const msg = getI18n().t("Common.please_input_real_phone");
    const flag = phoneNumber.getAllErrors().some((item) => item.text === msg);
    if (!flag) {
      phoneNumber.addError(msg);
    }
    // PHKL Custom -e
    return;
  }
  try {
    const res = await sendOtpReq({
      phoneNum: `${code} ${phoneNumber}`,
      ...actionParams, //PHKL Custom
    });
    if (!get(res, "errors", undefined)) {
      oid = res.oid;
      GlobalHelper.getGlobalDispatch()?.(sendOtpStartTimingAction(true)); //PHKL Custom
    }
  } catch (e: any) {
    const regionPhone = survey.getQuestionByName("regionPhone");
    //PHKL Custom -s
    const errorReturn = handlerError(e, undefined, actionParams.context);
    if (typeof errorReturn === "boolean" && errorReturn) {
      PruToast({
        message: getI18n().t("Common.server_error"),
        duration: 3000,
      });
      return;
    }
    //PHKL Custom -e
    if (errorReturn && typeof errorReturn === "string") {
      addUniqueErrorToQuestion(regionPhone, errorReturn);
    }
  }
};
export const getOid = () => {
  return oid;
};
export const setOid = (value?: string) => {
  oid = value;
};
